import { useEffect } from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router";

const RedirectPage = ({ url }) => {
  const params = useParams();
  useEffect(() => {
    let loc = `${url}`;
    if (params.subPath1) loc += `/${params.subPath1}`;
    if (params.subPath2) loc += `/${params.subPath2}`;
    window.location.replace(loc);
  }, [url, params.subPath1, params.subPath2]);
};

RedirectPage.propTypes = {
  url: PropTypes.string.isRequired,
};

export default RedirectPage;
